export default __webpack_public_path__ + "static/media/ms_MY.510c16b9.svg";